import axios from 'axios'
let sss = window.sessionStorage
export const Store = {
  get deviceID () {
    return sss.getItem('server/deviceID')
  },
  set deviceID (v) {
    sss.setItem('server/deviceID', v)
  },
  get shareLink () {
    return sss.getItem('server/shareLink')
  },
  set shareLink (v) {
    sss.setItem('server/shareLink', v)
  },
  get shareID () {
    return sss.getItem('server/shareID')
  },
  set shareID (v) {
    sss.setItem('server/shareID', v)
  },
  get avatarData () {
    return sss.getItem('server/avatarData')
  },
  set avatarData (v) {
    sss.setItem('server/avatarData', v)
  },
  get socialData () {
    return sss.getItem('server/socialData')
  },
  set socialData (v) {
    sss.setItem('server/socialData', v)
  }
}

function makeid () {
  var text = ''
  var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

  for (var i = 0; i < 12; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length))
  }

  return text
}

var setDefaultDeviceID = () => {
  Store.deviceID = makeid() // '_' + Math.random().toString(36).substr(2, 9)
  return Store.deviceID
}
var hydrate = () => {
  Store.deviceID = Store.deviceID || setDefaultDeviceID()
}

hydrate()

export const logMe = (funcName, input) => {
  return (res) => {
    console.log(funcName, 'input', input)
    console.log(funcName, 'output', res)
    return res
  }
}

export const api = axios.create({
  baseURL: 'https://radianceis.com.hk/'
})

/*
GET /api/count
*/
export const getRadianceCount = () => {
  // return Promise.resolve({ count: 3688 }).then(logMe('getRadianceCount'))
  return api.get('/api/count').then(resp => resp.data)
}

/*
POST /api/done/step
{
  id: 'local random id stored in session',
  step: 1
}
*/
export const recordStep = (data) => {
  // return Promise.resolve({ status: 'ok', isNew: true }).then(logMe('recordStep', data))
  return api.post('/api/step', {
    ...data,
    playId: Store.deviceID
  }).then(resp => resp.data)
}
/*
recordStep({
  id: 'localrandomID',
  step: 1
})
*/

/*
POST /api/form
{
  firstName: '',
  lastName: '',
  areaCode: '852',
  mobileNumber: '',
  email: '',

  getEmail: true,
  getMobile: true,
  getSMS: true
}
*/
export const submitForm = (data) => {
  // return Promise.resolve({ status: 'ok' }).then(logMe('submitForm', data))

  return api.post('/api/form', {
    ...data,
    playId: Store.deviceID
  }).then(resp => resp.data)
}
// submitForm({
//   firstName: '',
//   lastName: '',
//   areaCode: '852',
//   mobileNumber: '',
//   email: '',

//   getEmail: true,
//   getMobile: true,
//   getSMS: true
// }).then(logMe(''))

/*
POST /api/photo
{
  social: base64
  avatar: base64
}
result
{
  status: ok
  shareUrl: 'http:/.../api/share/<id>'
}
*/
export const sendPhoto = (data) => {
  // return Promise.resolve({ shareUrl: 'https://picsum.photos/200/300', status: 'ok' }).then(logMe('sendPhoto', data))

  return api.post('/api/photo', {
    ...data
  }).then(resp => resp.data)
}

// getRadiance().then(console.log)



// WEBPACK FOOTER //
// ./src/components/DOM/Server/Server.js